import { defineMessages } from 'react-intl';

export default defineMessages({
  totalAmount: {
    id: 'view.paymentMonext.totalAmount',
    defaultMessage: 'Total amount',
  },
  monextPaymentFailure: {
    id: 'view.paymentMonext.monextPaymentFailure',
    defaultMessage:
      'We got a payment failure, transaction is refused by the payment provider {retryButton}.',
  },
  retryButton: {
    id: 'view.paymentMonext.retryButton',
    defaultMessage: 'Retry',
  },
  paymentFailure: {
    id: 'view.paymentMonext.paymentFailure',
    defaultMessage: 'Payment failure',
  },
  paymentSuccess: {
    id: 'view.paymentMonext.paymentSuccess',
    defaultMessage: 'Payment success',
  },
  payButton: {
    id: 'view.paymentMonext.payButton',
    defaultMessage: 'Pay',
  },
});
